import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

const SkipToContentContainer = styled.a`
  position: fixed;
  color: ${Styles.color.white};
  top: -99999px;
  left: -99999px;
  opacity: 0;

  &:focus {
    top: 0.2rem;
    left: 0.2rem;
    opacity: 1;
  }
`;

const SkipToContent = () => {
  const { formatMessage } = useIntl();

  return (
    <SkipToContentContainer href="#main" tabIndex="0">
      {formatMessage({ id: 'skipToContent' })}
    </SkipToContentContainer>
  );
};

export default SkipToContent;
